<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="问卷名称"
          >
            <a-input
              placeholder="请输入问卷名称"
              :max-length="16"
              v-decorator="[
                'questionnaireName',
                validatorRules.questionnaireName
              ]"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="问卷类型"
          >
            <a-select
              placeholder="请选择问卷类型"
              v-decorator="['customerType', validatorRules.customerType]"
            >
              <a-select-option :value="0">机构</a-select-option>
              <a-select-option :value="1">个人</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="问卷头部"
          >
            <a-textarea
              placeholder="请输入问卷头部"
              v-decorator="['preRemark', {}]"
            ></a-textarea>
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="问卷尾部"
          >
            <a-textarea
              placeholder="请输入问卷尾部"
              v-decorator="['lastRemark', {}]"
            ></a-textarea>
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="问卷有效期"
          >
            <a-input-number
              v-decorator="[
                'validityDate',
                {
                  initialValue: 2,
                  rules: [{ validator: validateCustName }]
                }
              ]"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="有效期类型"
          >
            <a-radio-group
              name="radioGroup"
              v-decorator="['timeUnit', { initialValue: 3 }]"
            >
              <!-- <a-radio :value="0">
                永久
              </a-radio> -->
              <a-radio :value="1">
                日
              </a-radio>
              <a-radio :value="2">
                月
              </a-radio>
              <a-radio :value="3">
                年
              </a-radio>
              <!-- <a-radio :value="4">
                十年
              </a-radio> -->
            </a-radio-group>
          </a-form-item>
          <!-- <a-form-item
            label="上传文件"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            v-if="idns == 0"
          >
            <a-upload
              name="file"
              :multiple="true"
              accept=".xls,.xlsx"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :remove="handleRemove"
              @change="handleChange"
            >
              <a-button> <a-icon type="upload" />选择文件</a-button>
            </a-upload>

            <a
              @click="handleExportExcel('风险测评')"
              href="javascript:;"
              style="padding-left: 10px"
              >点击下载模板</a
            >
          </a-form-item> -->
        </a-row>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag, uploadAction, downFiles } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { getAction } from '../../../api/manage';
export default {
  props: {
    idns: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      title: '新增',
      visible: false,
      model: {},
      fileList: [],
      typeText: '',
      value: '',
      wid: '',
      id: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        customerType: { rules: [{ required: true, message: '请选择类型!' }] },
        questionnaireName: {
          rules: [{ required: true, message: '请输入问卷名称!' }]
        },
        email: { rules: [{ required: true, message: '请输入邮箱!' }] }
      },
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/save',
        edit: process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/save',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CONTENT + '/cont/questions/exportTemplateXls', //导出模板
        importExcelUrl:
          process.env.VUE_APP_CMS_CONTENT + '/cont/questions/importExcel', //导入
        riskId: process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/findWid' //获取问卷Id
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  methods: {
    validateCustName(rule, value, callback) {
      console.warn(value);
      if (value == '' || value == null) {
        this.form.setFieldsValue({
          timeUnit: ''
        });
        callback();
      } else {
        // this.form.setFieldsValue({
        //   timeUnit: 3
        // });
        callback();
      }
    },
    add() {
      this.form.resetFields();
      // getAction(this.url.riskId).then(res => {
      //   if (res.success) {
      //     this.id = res.result;
      //   }
      // });
      this.visible = true;
    },
    edit(record) {
      this.form.resetFields();
      this.wid = record.id;
      this.model = Object.assign({}, record);
      console.log(this.model, '>>>');
      this.visible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'preRemark',
              'customerType',
              'questionnaireName',
              'lastRemark',
              'email',
              'timeUnit',
              'validityDate'
            )
          );
        });
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange() {},
    handleOk() {
      const that = this;
      // 触发表单验证
      console.log(this.wid);
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (this.idns == 0) {
            httpurl += this.url.add;
            method = 'POST';
          } else {
            httpurl += this.url.edit;
            method = 'POST';
          }
          console.warn(values, 'values');
          if (values.validityDate == null) {
            values.timeUnit = '';
          }
          let formData = Object.assign(values);
          if (this.wid != '') {
            formData.id = this.wid;
          }
          console.log(this.model, formData, formData.isuse);
          //时间格式化
          // postTag(httpurl, formData)
          postTag(httpurl, formData).then(res => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', that.model);
              that.confirmLoading = false;
              that.close();
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    // 导出excel
    handleExportExcel(fileName) {
      console.log(this.id);
      let wid = null;
      if (this.id == '') {
        wid = this.wid;
      } else {
        wid = this.id;
      }
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      downFiles(this.url.exportXlsUrl, { wid: wid }).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    }

    // }
  }
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
